module.exports = __webpack_public_path__ + "img/gameplay-selected-square.90e860b7.svg";